import { render, staticRenderFns } from "./ctheader.vue?vue&type=template&id=bffb6e8e"
import script from "./ctheader.vue?vue&type=script&lang=js"
export * from "./ctheader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports